import { PieChart } from '@design/charts/pie-chart/PieChart';
import { SkeletonLoader } from '@design/components/skeleton-loader/SkeletonLoader';
import { SectionTitle } from '@terminal/components/section-title/SectionTitle';
import styles from '@terminal/views/theme-overview/tab-content/overview/industry-sector-distribution-section/IndustrySectorDistributionSection.module.scss';
import { useChartTheme } from '@terminal/views/turbo-chart/hooks/use-chart-theme/useChartTheme';
import { useTranslation } from 'react-i18next';
import { useMSThemeSectorDistributions } from './useMSThemeSectorDistributions';

export const IndustrySectorDistributionSection = ({
  entityTags,
}: {
  entityTags: string[];
}) => {
  const { themeName } = useChartTheme();
  const { t } = useTranslation(['widget']);

  const { isFetching, isError, data } = useMSThemeSectorDistributions({
    tags: entityTags,
  });

  if (isFetching) {
    return (
      <div className={styles.skeletonLoaderWrapper}>
        <SkeletonLoader
          areas={[
            {
              styles: {
                width: '100%',
                height: '100%',
                borderRadius: '8px',
              },
            },
          ]}
        />
      </div>
    );
  }

  if (isError || !data) {
    throw new Error('Sector Distribution: api error');
  }

  const { totalCompaniesCount, sectorDistributions } = data;

  const subtitleLabelText =
    totalCompaniesCount > 30
      ? t('widget:themeOverview.tabs.overview.topCompaniesByRankOver30', {
          count: totalCompaniesCount,
        })
      : t('widget:themeOverview.tabs.overview.topCompaniesByRankUnder30', {
          count: totalCompaniesCount,
        });

  return (
    <div className={styles.root}>
      <div className={styles.titleWrapper}>
        <div className={styles.sectionTitle}>
          <SectionTitle
            title={t('widget:themeOverview.tabs.overview.sectorDistribution')}
          />
        </div>
        <div className={styles.subtitleLabel}>{subtitleLabelText}</div>
      </div>
      <div className={styles.pieChartWrapper}>
        <PieChart theme={themeName} data={sectorDistributions} />
      </div>
    </div>
  );
};
